<template>
  <div class="alipay-flow-page">
    <div class="phone-screen">
      <img class="screen-image" :src="screenImage" alt="支付宝我的页面" />
      <button class="hotspot back-arrow" type="button" aria-label="返回上一页" @click="goBack" />
      <button class="hotspot settings-btn" type="button" aria-label="进入设置" @click="goSettings" />
      <button class="hotspot home-tab" type="button" aria-label="首页" @click="goHome" />
    </div>
  </div>
</template>

<script>
import screenImage from "@/assets/alipay-my-page-no-status.png";

export default {
  name: "AlipayMyPage",
  data() {
    return { screenImage };
  },
  methods: {
    goBack() {
      this.$router.back();
    },
    goSettings() {
      this.$router.push({ name: "AlipaySettingsPage" });
    },
    goHome() {
      this.$router.push({ name: "AlipayFlowHome" });
    },
  },
};
</script>

<style scoped>
.alipay-flow-page {
  min-height: 100vh;
  background: #eff2f7;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  box-sizing: border-box;
}
.phone-screen {
  position: relative;
  width: 100vw;
  height: 100vh;
}
.screen-image {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: fill;
  pointer-events: none;
}
.hotspot {
  position: absolute;
  z-index: 2;
  border: none;
  background: transparent;
  cursor: pointer;
}
.back-arrow {
  left: 1.5%;
  top: 0.8%;
  width: 9%;
  height: 6%;
}
.settings-btn {
  right: 2%;
  top: 2.8%;
  width: 9%;
  height: 5.5%;
}
.home-tab {
  left: 0.5%;
  bottom: 0;
  width: 20%;
  height: 9%;
}
</style>
